/** @jsxImportSource @emotion/react */
"use client";

import type { Interpolation } from "@emotion/react";
import { useLocale } from "@i18n/next";
import type { ThemeType } from "@packages/ui";
import { CheckmarkIcon, radius, spacing, Text } from "@packages/ui";

const baseStyles: Interpolation<ThemeType> = (theme: ThemeType) => ({
  alignItems: "center",
  border: `2px solid ${theme.semanticColors.neutralsLowest}`,
  borderRadius: radius.m,
  cursor: "pointer",
  display: "flex",
  gap: spacing.l,
  padding: spacing.l,
  "&:hover": {
    background: theme.semanticColors.neutralsLowest,
  },
});

type LanguageOptionProps = {
  label: string;
  value: string;
  onClick: (key: string) => void;
};

const LanguageOption = ({ label, value, onClick }: LanguageOptionProps) => {
  const locale = useLocale();
  const Icon =
    locale === value ? CheckmarkIcon.FilledOn : CheckmarkIcon.Outline.Off;
  return (
    <li css={baseStyles} onClick={() => onClick(value)}>
      <Icon />
      <Text size="m" type="title">
        {label}
      </Text>
    </li>
  );
};

export default LanguageOption;
